import { render, staticRenderFns } from "./PhoneNetwork.vue?vue&type=template&id=5597eedd"
import script from "./PhoneNetwork.vue?vue&type=script&lang=js"
export * from "./PhoneNetwork.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports